<h3 mat-dialog-title>Przekazywanie opłaty</h3>

<p>
  Wszystkie nieopłacone opłaty od <b>{{ data.description }}</b> będą automatycznie przekazywane do
  {{ data.targetEmail }}.
</p>

<p>
  Odbiorca będzie miał 14 dni na zaakceptowanie przekazywania. O opłaceniu poinformujemy Cię mailowo oraz w aplikacji.
</p>

<p>Czy chcesz włączyć przekazywanie opłat?</p>

<mat-dialog-actions align="start">
  <button mat-raised-button color="accent" [matDialogClose]="true">Włącz przekazywanie</button>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
